import uuid from 'uuid';

import { UserStatus, TestEntitiesData, TestEntitiesIds } from 'chaika-enums';

export const mockAuthUser = {
    id: TestEntitiesIds.UserId,
    status: UserStatus.Active,
    email: TestEntitiesData.UserEmail,
    firstName: '',
    lastName: '',
    roles: [
        {
            id: '808ac867-647e-4799-87d5-e85492af1f19',
            name: 'admin',
        },
        {
            id: 'f1402189-9a14-4e07-8478-aa58c51db38a',
            name: 'superAdmin',
        },
        { id: uuid.v4(), name: 'doctor' },
    ],
};
